import { object, string, array } from 'yup';
import i18n from '../../../i18n';

// Types
import { TeamManagement } from './types';

export const TeamManagementSchema = object<TeamManagement>({
    name: string()
        .trim()
        .required(() => i18n.t('validation:required'))
        .min(1, () => i18n.t('validation:required')),
    concessionIDs: array().of(string()),
    roadIDs: array().of(string()),
    userIDs: array().of(string()),
    vehicleIDs: array().of(string()),
});
